import ReportsTable from './ReportsTable';

export default function ReportsComponent() {
  return (
    <div>
      <ReportsTable />
    </div>
  );
}
